import React from 'react'
import PropTypes from 'prop-types'
import { format } from 'date-fns'

import MessageBlock from '../../../../../../../features/components/Form/MessageBlock'
import SelectDifferentInventoryValidationMessage from './SelectDifferentInventoryValidationMessage'

import useNoOverlappingGamTargetingValidation from '../../hooks/useNoOverlappingGamTargetingValidation'

import { DATES_FORMAT_FULL_YEAR } from '../../../../../../../constants/dates'
import { END_DATE, START_DATE } from '../../../../../../ReusableFormFields/StartEndDateRangeFields/fields'

import useStyles from './styles'

const NoOverlappingGamTargetingValidationMessage = ({ formValues, onValidationChange, canSelectInventory = true }) => {
  const classes = useStyles()
  const validationResult = useNoOverlappingGamTargetingValidation(formValues, onValidationChange)

  if (validationResult.isValid || validationResult.errors.length === 0) {
    return null
  }

  const startDate = formValues[START_DATE]
  const endDate = formValues[END_DATE]
  const startDateFormatted = format(new Date(startDate), DATES_FORMAT_FULL_YEAR)
  const endDateFormatted = format(new Date(endDate), DATES_FORMAT_FULL_YEAR)

  return (
    <div className={classes.validationMessage}>
      {validationResult.errors.map((error, index) => (
        <MessageBlock key={index} title="Inventory Targeting Conflict" state="warning" borderColor="warning">
          <div>{error}</div>
          <div className={classes.resolutionSection}>
            <div className={classes.resolutionTitle}>To resolve this conflict:</div>
            <ul className={classes.resolutionList}>
              {canSelectInventory ? (
                <SelectDifferentInventoryValidationMessage formValues={formValues} />
              ) : (
                <>
                  <li>{`Go back to the Inventory Targeting step and only select inventory that is not already targeted by existing line items on ${startDateFormatted} - ${endDateFormatted}`}</li>
                  <li>
                    Select dates that are not faded out as these are dates on which all of the inventory you have chosen
                    to target with this line item is available for targeting
                  </li>
                </>
              )}
            </ul>
          </div>
        </MessageBlock>
      ))}
    </div>
  )
}

NoOverlappingGamTargetingValidationMessage.propTypes = {
  formValues: PropTypes.object.isRequired,
  onValidationChange: PropTypes.func.isRequired
}

export default NoOverlappingGamTargetingValidationMessage
